// @ts-nocheck
import OrderUploadReducer from "@insite/client-framework/Store/Components/OrderUpload/OrderUploadReducer";
import StoreListUploadReducer, {
    StoreListUploadActions,
} from "@store/Framework/Store/Components/StoreListUpload/StoreListUploadReducer";
import { combineReducers } from "redux";

const componentReducers = {
    orderUpload: OrderUploadReducer,
    storeListUpload: StoreListUploadReducer,
};

export type StoreComponentsActions = typeof componentReducers | StoreListUploadActions;

const componentsReducer = combineReducers(componentReducers as any);
export default componentsReducer;
